import React, { Component } from "react";
import locales from "../../../_constants/locales";
import "../styles/PersonalInformation.css";

class GeneralInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedReturnItems: [],
            expandedReplacementItems: [],
            isUpdateAddressDialogOpen: false
        };
    }

    handleRequestAssistanceClick() {
        window.open("https://help.kobo.com/", "_blank", "noreferrer");
    }

    handleUpdateAddressClick() {
        this.setState({
            isUpdateAddressDialogOpen: true
        });
    }

    handleCancelAddressUpdateClick() {
        this.setState({
            isUpdateAddressDialogOpen: false
        });
    }

    render() {
        return (
            <div className="flex layout vertical">
                <form
                    className="flex layout vertical"
                    autoComplete="off"
                    onSubmit={e => {
                        e.preventDefault();
                    }}
                >
                    <div className="flex layout horizontal first-name-last-name-box">
                        <div className="flex layout vertical custom-textfield-inactive">
                            <p className="custom-textfield-inactive-label">
                                {locales[this.props.language.code].TICKET_CONFIRMATION.PERSONAL_INFORMATION.FIRST_NAME.LABEL}
                            </p>

                            <p id="personal-information-first-name" className="custom-textfield-inactive-value">
                                {this.props.personalInformation.firstName}
                            </p>
                        </div>
                        {/* <TextField
                            autoComplete="off"
                            disabled
                            value={this.props.personalInformation.firstName}
                            className="flex custom-textfield"
                            label={locales[this.props.language.code].TICKET_CONFIRMATION.PERSONAL_INFORMATION.FIRST_NAME.LABEL}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true
                            }}
                        /> */}
                        <div className="flex layout vertical custom-textfield-inactive">
                            <p className="custom-textfield-inactive-label">
                                {locales[this.props.language.code].TICKET_CONFIRMATION.PERSONAL_INFORMATION.LAST_NAME.LABEL}
                            </p>
                            <p id="personal-information-last-name" className="custom-textfield-inactive-value">
                                {this.props.personalInformation.lastName}
                            </p>
                        </div>
                        {/* <TextField
                            autoComplete="off"
                            disabled
                            value={this.props.personalInformation.lastName}
                            className="flex custom-textfield"
                            label={locales[this.props.language.code].TICKET_CONFIRMATION.PERSONAL_INFORMATION.LAST_NAME.LABEL}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true
                            }}
                        /> */}
                    </div>
                    <div className="flex layout horizontal email-address-phone-number">
                        <div className="flex layout vertical custom-textfield-inactive">
                            <p className="custom-textfield-inactive-label">
                                {locales[this.props.language.code].TICKET_CONFIRMATION.PERSONAL_INFORMATION.EMAIL_ADDRESS.LABEL}
                            </p>
                            <p id="personal-information-email-address" className="custom-textfield-inactive-value">
                                {this.props.personalInformation.emailAddress}
                            </p>
                        </div>
                        {/* <TextField
                            autoComplete="off"
                            disabled
                            value={this.props.personalInformation.emailAddress}
                            className="flex custom-textfield"
                            label={locales[this.props.language.code].TICKET_CONFIRMATION.PERSONAL_INFORMATION.EMAIL_ADDRESS.LABEL}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true
                            }}
                        /> */}
                        <div className="flex layout vertical custom-textfield-inactive">
                            <p className="custom-textfield-inactive-label">
                                {locales[this.props.language.code].TICKET_CONFIRMATION.PERSONAL_INFORMATION.PHONE_NUMBER.LABEL}
                            </p>
                            <p id="personal-information-phone-number" className="custom-textfield-inactive-value">
                                {this.props.personalInformation.phoneNumber}
                            </p>
                        </div>
                        {/* <TextField
                            autoComplete="off"
                            disabled
                            value={this.props.personalInformation.phoneNumber}
                            className="flex custom-textfield"
                            label={locales[this.props.language.code].TICKET_CONFIRMATION.PERSONAL_INFORMATION.PHONE_NUMBER.LABEL}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true
                            }}
                        /> */}
                    </div>
                </form>
            </div>
        );
    }
}

export default GeneralInformation;
